import * as React from 'react';
// @ts-expect-error
import type {MutationFunction} from 'react-apollo';

import {IntegrationWidget} from 'shells/integration-widget/integration-widget';

import {authToService} from '../integrations/auth-to-service';
import {getAuthResults} from '../integrations/integration-mutation-response-helpers';

type Variables = {
    isEnabled: boolean;
};

export type AuthSuccessResult = {
    username?: string;
};

type Props<T> = {
    initialText: string;
    authCheckUrl: string;
    windowFeatures: any;
    enable: T;
    logo: React.ReactElement<any>;
    onAuthStart?: () => void;
    onAuthSuccess: (arg1?: AuthSuccessResult | null | undefined) => Promise<any>;
    onAuthError: (arg1: string[]) => void;
    disabled?: boolean;
    isFullWidth?: boolean;
    connectOnMount?: boolean;
    centerContent?: boolean;
    compact?: boolean;
    borderVariant?: 'default' | 'ai' | 'feature';
    forceReauth?: boolean;
};

export function InitialButton<T extends MutationFunction<any, Variables>>(props: Props<T>) {
    const {initialText, authCheckUrl, windowFeatures, connectOnMount} = props;

    return (
        <IntegrationWidget
            status='initial'
            account={null}
            initialText={initialText}
            logo={props.logo}
            disabled={props.disabled}
            connectOnMount={connectOnMount}
            centerContent={props.centerContent}
            compact={props.compact}
            borderVariant={props.borderVariant}
            onConnectClick={() => {
                props
                    .enable({
                        variables: {isEnabled: true, forceReauth: props.forceReauth},
                        update: () => {},
                    })
                    .then(getAuthResults)
                    // @ts-expect-error
                    .then(({authUrl, newConnectionId}) => {
                        // If we get an authUrl back, then we need to auth
                        if (authUrl) {
                            if (props.onAuthStart) {
                                props.onAuthStart();
                            }
                            authToService({
                                authUrl,
                                authCheckUrl,
                                windowFeatures,
                                connectionId: newConnectionId,
                            })
                                .then(({hasAuth, username}) => {
                                    if (hasAuth) {
                                        props.onAuthSuccess({username});
                                    }
                                })
                                .catch((errorMessages) => {
                                    props.onAuthError(errorMessages);
                                });
                        }
                    });
            }}
            onDisconnectClick={() => {}}
            fullWidthInitialButton={props.isFullWidth}
        />
    );
}
